<template>
  <div class="tool-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('tool_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-tools</v-icon>{{$t('profile.tool.tools')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ToolFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.number" slot-scope="{ item }">
                  {{ $n(item['number']) }}
                </template>
                <template slot="item.extruders" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['extruders']" :key="_item.id">
                      {{ _item.id }}
                    </li>
                  </ul>
                </template>
                <template slot="item.heater" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['heater']" :key="_item.id">
                      {{ _item.id }}
                    </li>
                  </ul>
                </template>
                <template slot="item.toolHeadSubs" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['toolHeadSubs']" :key="_item.id">
                      {{ _item.id }}
                    </li>
                  </ul>
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ToolFilterForm from '../../components/tool/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ToolList',
  servicePrefix: 'Tool',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ToolFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.tool.name'), value: 'name' },
        { text: this.$t('profile.tool.number'), value: 'number' },
        { text: this.$t('profile.tool.toolheaddef'), value: 'toolHeadDef' },
        { text: this.$t('profile.tool.comment'), value: 'comment' },
        { text: this.$t('global.archive'), value: 'archive'},
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('tool', {
      items: 'list'
    }),
    ...mapFields('tool', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('tool', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
